"use client"

import { getFixedT } from "@/languages/i18n"
import { DefaultImage } from "@/lib/external-components"
import { toImageSrc } from "@/lib/utils"
import { QuickLinksContentProps } from "@/types/types"
import Image from "next/image"
import Link from "next/link"
import { twMerge } from "tailwind-merge"

export const QuickLinksContent = ({ id, links, className, locale }: QuickLinksContentProps) => {
  const t = getFixedT(locale)
  return (
    <div id={id} className={twMerge("w-full py-8 lg:py-16 bg-white", className)}>
      <div className="container">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {links.map((link, index) => {
            const imageUrl = link.image ? toImageSrc(link.image) : ""
            const imageSrc = imageUrl || DefaultImage

            return (
              <Link
                key={index}
                href={link.link || "#"}
                className="group block bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-200 hover:border-[#157e40]"
              >
                <div className="relative w-full h-48 lg:h-64 overflow-hidden">
                  <Image
                    alt={link.title}
                    src={imageSrc}
                    fill
                    className="object-cover group-hover:scale-110 transition-transform duration-300"
                    sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div className="p-6 lg:p-8">
                  <h3 className="text-xl lg:text-2xl font-bold text-gray-900 mb-3 group-hover:text-[#157e40] transition-colors duration-300">
                    {link.title}
                  </h3>
                  {link.description && (
                    <p className="text-gray-600 text-sm lg:text-base leading-relaxed line-clamp-3">
                      {link.description}
                    </p>
                  )}
                  <div className="mt-4 flex items-center text-[#157e40] font-semibold text-sm lg:text-base group-hover:translate-x-2 transition-transform duration-300">
                    {t("See more")}
                    <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}
